/* eslint-disable no-shadow */
export enum FilterSections {
	ozonersList = 'ozonersList',
	vehiclesList = 'vehiclesList',
	creditsList = 'creditsList',
	formsList = 'formsList',
	ozociosList = 'ozociosList',
	extVehicleList = 'extVehicleList',
}

export enum Roles {
	ADMIN = 'ADMIN',
	INVENTORY_MANAGER = 'INVENTORY_MANAGER',
	INVENTORY_PRICE_MANAGER = 'INVENTORY_PRICE_MANAGER',
	INVENTORY_MODEL_MANAGER = 'INVENTORY_MODEL_MANAGER',
	DEVICES_MANAGER = 'DEVICES_MANAGER',
	CREDIT_ANALYST = 'CREDIT_ANALYST',
	COLLECTOR_MANAGER = 'COLLECTOR_MANAGER',
	BUYER_MANAGER = 'BUYER_MANAGER',
	RECUPERATOR_MANAGER = 'RECUPERATOR_MANAGER',
	RECUPERATOR_AGENT = 'RECUPERATOR_AGENT',
	GPS_VIEWER = 'GPS_VIEWER',
	GPS_MANAGER = 'GPS_MANAGER',
	SELLER = 'SELLER',
	USER_MANAGMENT = 'USER_MANAGMENT',
	SYSTEM = 'SYSTEM',
}

export const rolesExcluding = (...excluded: Roles[]): Roles[] =>
	Object.values(Roles).filter(
		(role) => role !== Roles.SYSTEM && !excluded.includes(role),
	);

export enum OzonioDocumentType {
	birth_certificate = 'birth_certificate',
	IMSS = 'IMSS',
	RFC = 'RFC',
	ine_front = 'ine_front',
	ine_back = 'ine_back',
	proof_of_address = 'proof_of_address',
	bank_account = 'bank_account',
	studies_certificate = 'studies_certificate',
	INFONAVIT = 'INFONAVIT',
	work_references = 'work_references',
	contract = 'contract',
	other_license = 'other_license',
	other_medical_leave = 'other_medical_leave',
	other_notifications = 'other_notifications',
	CV = 'CV',
	enneagram = 'enneagram',
	technical_test = 'technical_test',
	other_selection_process = 'other_selection_process',
}

export const OzonioDocumentTypeValues = {
	[OzonioDocumentType.IMSS]: {
		title: 'IMSS',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.birth_certificate]: {
		title: 'Cert. Nacimiento',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.RFC]: {
		title: 'RFC/RUT',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.ine_front]: {
		title: 'ID Frontal',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.ine_back]: {
		title: 'ID Reverso',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.proof_of_address]: {
		title: 'Cert. Domicilio',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.bank_account]: {
		title: 'Cert. Bancario',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.studies_certificate]: {
		title: 'Cert. Estudios',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.INFONAVIT]: {
		title: 'INFONAVIT',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.work_references]: {
		title: 'Ref. Laborales',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.contract]: {
		title: 'Contrato',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.other_license]: {
		title: 'Otro',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.other_medical_leave]: {
		title: 'Otro',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.other_notifications]: {
		title: 'Otro',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.CV]: {
		title: 'Hoja de Vida',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.enneagram]: {
		title: 'Eneagrama',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.technical_test]: {
		title: 'Prueba Tecnica',
		accept: 'image/png, image/jpeg, application/pdf',
	},
	[OzonioDocumentType.other_selection_process]: {
		title: 'Otro',
		accept: 'image/png, image/jpeg, application/pdf',
	},
};
